var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('notifications',{staticClass:"notifications-message",attrs:{"speed":_vm.options.speed,"duration":_vm.options.duration,"position":"bottom center","animation-name":"snackbar"},nativeOn:{"click":function($event){return _vm.onClick($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }